<template>
  <div class="inline-block">
    <div
      v-if="show_ellipsis_trigger"
      class="flex size-10 shrink-0 cursor-pointer items-center justify-center rounded-full hover:bg-gray-100"
      :data-test="data_test"
      @click.stop.prevent="(event) => togglePopover(event)"
    >
      <FontAwesomeIcon
        class="flex-center text-gray-500"
        :icon="['far', 'ellipsis']"
        size="lg"
      />
    </div>

    <component
      :is="button_component"
      v-else
      :action="action"
      :data-test="data_test"
      :hide_text="hide_text"
      v-bind="button_props"
      @click="togglePopover"
    >
      <div class="flex items-center gap-2">
        <FontAwesomeIcon
          v-if="icon"
          :icon="icon"
        />
        <span v-if="text">{{ text }}</span>
        <slot name="trigger" />
      </div>
    </component>

    <Popover
      ref="popover"
      class="z-2000!"
      :pt="{ content: '!p-0 !m-0' }"
    >
      <div class="flex flex-col">
        <slot />
      </div>
    </Popover>
  </div>
</template>

<script setup>
import { computed, provide, ref, useSlots } from 'vue';

const slots = useSlots();

const props = defineProps({
  icon: { type: [String, Array], default: null },
  text: { type: String, default: null },
  data_test: { type: String, default: 'button-dropdown' },
  variant: {
    type: String,
    default: 'secondary',
    validator: (v) => ['secondary', 'tertiary', 'icon'].includes(v),
  },
  action: { type: String, default: null },
  hide_text: { type: Boolean, default: false },
  button_props: { type: Object, default: () => ({}) },
});

const popover = ref(null);

const has_trigger_slot = computed(() => !!slots.trigger);

const show_ellipsis_trigger = computed(() => {
  if (has_trigger_slot.value) return false;
  if (props.variant === 'icon') return true;
  return !props.icon && !props.text;
});

const button_component = computed(() => {
  if (props.variant === 'tertiary' || props.variant === 'icon') return 'ButtonTertiary';
  return 'ButtonSecondary';
});

const togglePopover = (event) => {
  popover.value?.toggle(event);
};

const hide = () => {
  popover.value?.hide();
};

provide('dropdownHide', hide);

defineExpose({ togglePopover, hide });
</script>
